module.exports = __webpack_public_path__ + "img/neutrals-icon.48c81206.png";